import React from "react";
import PropTypes from "prop-types";
import { Card, Table, Tag, Typography, Tooltip } from "antd";
import { BarChartOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import { useContext } from "react";
import { ProfileContext } from "Common/hooks/context/ProfileContext";
const { Text } = Typography;
const TrainingTable = ({ styles, darkMode, trainings }) => {
  const { isProfileComplete } = useContext(ProfileContext);
  const isBlocked = !isProfileComplete;
  const handleTableClick = () => {
    if (isBlocked) return;
  };
  const handleRowClick = (record) => {
    if (isBlocked) return;
    console.log('Training clicked:', record);
  };
  const columns = [
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      render: (text, record) => (
        <Tooltip title={isBlocked ? "Complete your profile to access this feature" : ""}>
          <div
            style={{
              position: "relative",
              display: "flex",
              alignItems: "center",
              cursor: isBlocked ? 'not-allowed' : 'pointer'
            }}
            onClick={() => handleRowClick(record)}
          >
            <Text strong style={{ opacity: isBlocked ? 0.6 : 1 }}>
              {text}
            </Text>
            {record.isRetryTraining && (
              <Tag
                color="orange"
                style={{
                  marginLeft: 8,
                  fontWeight: "bold",
                  opacity: isBlocked ? 0.6 : 1
                }}
              >
                Repeated
              </Tag>
            )}
          </div>
        </Tooltip>
      ),
    },
    {
      title: "Mentor",
      dataIndex: "mentorName",
      key: "mentorName",
      render: (text) => (
        <Text style={{ opacity: isBlocked ? 0.6 : 1 }}>
          {text}
        </Text>
      ),
    },
    {
      title: "Start Date",
      dataIndex: "startDate",
      key: "startDate",
      render: (date) => (
        <Text style={{ opacity: isBlocked ? 0.6 : 1 }}>
          {date ? dayjs(date).format("DD MMM YYYY") : <Text type="secondary">N/A</Text>}
        </Text>
      ),
    },
    {
      title: "End Date",
      dataIndex: "endDate",
      key: "endDate",
      render: (date) => (
        <Text style={{ opacity: isBlocked ? 0.6 : 1 }}>
          {date ? dayjs(date).format("DD MMM YYYY") : <Text type="secondary">N/A</Text>}
        </Text>
      ),
    },
    {
      title: "Progress",
      dataIndex: "progress",
      key: "progress",
      render: (value) => {
        let color = "default";
        if (value >= 80) color = "green";
        else if (value >= 50) color = "orange";
        else color = "red";

        return (
          <Tag
            color={color}
            style={{ opacity: isBlocked ? 0.6 : 1 }}
          >
            {value}%
          </Tag>
        );
      },
    },
  ];
  return (
    <Tooltip title={isBlocked ? "Complete your profile to access this feature" : ""}>
      <Card
        title={
          <span style={{
            ...styles.cardTitle,
            opacity: isBlocked ? 0.6 : 1
          }}>
            <BarChartOutlined style={{ marginRight: 8 }} />
            Trainings
          </span>
        }
        hoverable
        style={{
          ...styles.card,
          boxShadow: darkMode ? "0 2px 8px rgba(255, 255, 255, 0.1)" : "0 2px 8px rgba(0, 0, 0, 0.1)",
          borderRadius: 12,
          cursor: isBlocked ? 'not-allowed' : 'default',
          opacity: isBlocked ? 0.6 : 1
        }}
        onClick={handleTableClick}
      >
        <Table
          columns={columns}
          dataSource={trainings}
          scroll={{ x: "max-content" }}
          pagination={{ pageSize: 5 }}
          style={{
            marginTop: 16,
            opacity: isBlocked ? 0.6 : 1
          }}
          rowKey={(record, index) => `${record.title}-${index}`}
          onRow={(record) => ({
            onClick: () => handleRowClick(record),
            style: {
              cursor: isBlocked ? 'not-allowed' : 'pointer',
            }
          })}
        />
      </Card>
    </Tooltip>
  );
};
TrainingTable.propTypes = {
  styles: PropTypes.shape({
    card: PropTypes.object,
    cardTitle: PropTypes.object,
  }).isRequired,
  darkMode: PropTypes.bool.isRequired,
  trainings: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      mentorName: PropTypes.string.isRequired,
      startDate: PropTypes.string,
      endDate: PropTypes.string,
      progress: PropTypes.number.isRequired,
      isRetryTraining: PropTypes.bool,
    })
  ).isRequired,
};
export default TrainingTable;